import EstablishmentContactForm from "./EstablishmentContactForm";

type BillingManagerFormProps = {
    goto: (step: number) => void;
    nextStep: number;
    profilId: string;
};

export default function EstablishmentBillingManagerForm({
    goto,
    nextStep,
    profilId,
}: BillingManagerFormProps) {
    const title = "Coordonnées du responsable facturation";
    const subTitle =
        "Renseignez les informations des personnes à contacter en cas de besoin";
    const jobTitle = "Le responsable facturation";
    return (
        <EstablishmentContactForm
            goto={() => goto(nextStep)}
            nextStep={nextStep}
            profilId={profilId}
            title={title}
            subTitle={subTitle}
            jobTitle={jobTitle}
        />
    );
}
